<div class="d-flex flex-column justify-content-center">
  <div class="row loading-row">
    <div class="spinner">
      <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
    </div>
  </div>
</div>
